<template>
<div class="wrapper">
  <div class="container details">
    <div class="row">
      <div class="col-md-12">
        <h1>Skapa ny order</h1>
      </div>
    </div>
    <div class="row orderDetailsWrapper">
      <div class="col-md-12">
        <form class="formGeneratorWithColumns">
          <vue-form-generator tag="div" :schema="activeSchema" :model="orderModel" />
        </form>
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button label="Skapa" class="p-button-success" @click="onSave(currentOrder)" icon="pi pi-check" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Button from 'primevue/button'
export default {
  name: 'OrderCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Button
  },
  data () {
    return {
      schema: {},
      orderModel: {},
      activeSchema: {},
      fractions: {}
    }
  },
  async mounted () {
    this.schema = this.$route.params.schema
    this.activeInputs()
    this.getTrucks()
    this.fractions = await this.getFractions()
    this.getAVC()
  },
  methods: {
    activeInputs () {
      this.activeSchema = Object.assign({}, this.schema)
      this.activeSchema.fields = this.activeSchema.fields.filter((c) => c.activeInDetails)
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.fields.find(field => field.model === 'truck')
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          var trucks = response.data.filter(truck => (truck.objectDescriptionId === 2 || truck.objectDescriptionId === 3))
          trucks.sort(function (a, b) {
            if (a.data.regnbr < b.data.regnbr) { return -1 }
            return 0
          })
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr, 'type': trucks[i].ObjectDescription.name})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getAVC () {
      var avcSelect = this.activeSchema.fields.find(field => field.model === 'avcs')
      this.$http
        .get('/api/containerorders/getavcs')
        .then(async response => {
          let avcs = response.data
          let standardPlaces = response.data.filter((c) => c.data.inActive !== true && (c.data.type === 'Mellanlagring' || c.data.type === 'Service'))
          let arrStandardPlaces = []
          for (var d = 0; d < standardPlaces.length; d++) {
            let standardPlace = {id: standardPlaces[d].id, address: standardPlaces[d].data.address, name: standardPlaces[d].data.name, type: standardPlaces[d].data.type}
            arrStandardPlaces.push(standardPlace)
          }
          for (var i = 0; i < avcs.length; i++) {
            let arrForbehandlare = []
            let selectedForbehandlare = null
            if (avcs[i].forbehandlare.length > 0) {
              selectedForbehandlare = {id: avcs[i].forbehandlare[0].id, name: avcs[i].forbehandlare[0].data.name + ' ' + avcs[i].forbehandlare[0].data.address, addess: avcs[i].forbehandlare[0].data.address, fractions: avcs[i].forbehandlare[0].data.fraktioner}
              for (var b = 0; b < avcs[i].forbehandlare.length; b++) {
                arrForbehandlare.push({id: avcs[i].forbehandlare[b].id, name: avcs[i].forbehandlare[b].data.name + ' ' + avcs[i].forbehandlare[b].data.address, address: avcs[i].forbehandlare[b].data.address, fractions: avcs[i].forbehandlare[b].data.fraktioner})
                if (avcs[i].forbehandlare[b].chosen) {
                  selectedForbehandlare = {id: avcs[i].forbehandlare[b].id, name: avcs[i].forbehandlare[b].data.name + ' ' + avcs[i].forbehandlare[b].data.address, address: avcs[i].forbehandlare[b].data.address, fractions: avcs[i].forbehandlare[b].data.fraktioner}
                }
              }
            }
            let containers = await this.getContainers(avcs[i].id)
            avcSelect.values.push({'objectId': avcs[i].objectId, 'id': avcs[i].id, 'name': avcs[i].data.name, 'type': avcs[i].data.type, 'city': avcs[i].data.city, 'address': avcs[i].data.address, 'selectedFraction': avcs[i].fraction, 'fractions': this.fractions, 'selectedForbehandlare': selectedForbehandlare, 'forbehandlare': arrForbehandlare, 'containerAmount': 0, notice: avcs[i].notice, 'standardPlaces': arrStandardPlaces, containers: containers, comment: '', globalComments: []})
          }
        })
        .catch(error => console.log(error))
    },
    async getFractions () {
      const response = await this.$http.get('/api/objectdatas/objectdescriptionid/22')
      return response.data.map((el) => ({id: el.id, name: el.data.name}))
    },
    async getContainers (id) {
      let containers = await this.$http.get('/api/containercurrlogsByPlace/' + id)
      containers.data = containers.data.filter(function (obj) {
        return obj.container.data.status !== 'Inaktiv'
      })
      return containers.data
    },
    onSave () {
      var url = '/api/orders'
      this.$http
        .post(url, {
          order: {
            type: 'container',
            state: 'ny',
            needsAttention: 0,
            data: this.orderModel
          }
        })
        .then(response => {
          this.$router.go(-1)
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/ContainerOrderCreate.vue